module.exports = __webpack_public_path__ + "assets/img/home_about.ad066074.png";